import { atom } from 'recoil';
import { CookieKeys } from '../../../utility/Constant';
import { Cookie } from '../../../utility/Cookie';

const defaultClientSync = {
  syncedUsingClientId: null,
  syncedUsingUserId: null,
}
const clientState = Cookie.getItem(CookieKeys.clientSync) || defaultClientSync;
const clientSyncState = atom({
  key: 'clientSync',
  default: clientState,
});

export default clientSyncState;
